import type { SupportTranslations } from './types'

export const urTranslations: SupportTranslations = {
  title: 'سپورٹ ٹکٹس',
  subtitle: 'کسٹمر اور اندرونی سپورٹ درخواستوں کا انتظام',
  newTicket: 'نیا ٹکٹ',
  createForbidden: 'آپ کو سپورٹ ٹکٹ بنانے کی اجازت نہیں ہے، منتظم سے اجازت شامل کرنے کی درخواست کریں',
  getHelp: 'مدد حاصل کریں',
  submitTicket: 'ٹکٹ جمع کرائیں',
  submit: 'ٹکٹ جمع کرائیں',

  statusOpen: 'کھلا',
  statusInProgress: 'جاری',
  statusWaiting: 'رپورٹر کا انتظار',
  statusResolved: 'حل ہو گیا',
  statusClosed: 'بند',

  priorityLow: 'کم',
  priorityMedium: 'درمیانہ',
  priorityHigh: 'زیادہ',
  priorityUrgent: 'فوری',

  channelCustomer: 'کسٹمر',
  channelInternal: 'اندرونی',
  allChannels: 'تمام چینلز',
  filterChannel: 'چینل',

  categoryOrder: 'آرڈر کا مسئلہ',
  categoryDelivery: 'ڈیلیوری کا مسئلہ',
  categoryPayment: 'ادائیگی کا مسئلہ',
  categoryAccount: 'اکاؤنٹ کا مسئلہ',
  categoryBug: 'پلیٹ فارم بگ',
  categoryHardware: 'ہارڈویئر کی خرابی',
  categoryFeature: 'فیچر کی درخواست',
  categoryGeneral: 'عام',
  categoryOther: 'دیگر',

  statsOpen: 'کھلے',
  statsInProgress: 'جاری',
  statsResolved: 'حل شدہ',
  statsTotal: 'کل',

  colTicket: 'ٹکٹ نمبر',
  colSubject: 'موضوع',
  colChannel: 'چینل',
  colCategory: 'زمرہ',
  colPriority: 'ترجیح',
  colStatus: 'حالت',
  colCreated: 'تاریخ',
  colSla: 'ایس ایل اے',
  slaMet: 'ایس ایل اے پورا ہوا',
  slaBreached: 'ایس ایل اے کی خلاف ورزی',
  slaOutcome: 'ایس ایل اے نتیجہ',
  slaSelect: 'کیا ایس ایل اے پورا ہوا؟',
  slaOpenFor: 'کھلا ہے',
  slaTarget: 'ہدف',
  slaDue: 'مقررہ',
  slaSuggestMet: 'ہدف کے اندر — تجویز: ایس ایل اے پورا ہوا',
  slaSuggestBreached: 'ہدف سے تجاوز — تجویز: ایس ایل اے کی خلاف ورزی',

  fieldFactory: 'پلانٹ',
  selectFactory: 'پلانٹ منتخب کریں',
  fieldSubject: 'موضوع',
  fieldCategory: 'زمرہ',
  fieldPriority: 'ترجیح',
  fieldDescription: 'تفصیل',
  fieldEmail: 'ای میل',
  fieldPhone: 'فون نمبر',
  fieldAttachments: 'تصاویر',
  subjectPlaceholder: 'اپنے مسئلے کا مختصر خلاصہ',
  selectCategory: 'زمرہ منتخب کریں',
  descriptionPlaceholder: 'اپنے مسئلے کی تفصیل بیان کریں...',
  emailPlaceholder: 'email@example.com',
  phonePlaceholder: '٩٦٦+ 5X XXX XXXX',
  attachmentsHint: 'زیادہ سے زیادہ 5 تصاویر اپ لوڈ کریں (ہر ایک 10MB تک)',
  attachmentsRequired: 'کم از کم ایک تصویر لازمی ہے',
  removePhoto: 'تصویر ہٹائیں',
  addPhoto: 'تصاویر شامل کرنے کے لیے کلک کریں',
  addPhotoFormats: 'JPG، PNG، WEBP، GIF',
  fileTooLarge: 'فائلز 10MB سے کم ہونی چاہئیں',
  photo: 'تصویر',
  photos: 'تصاویر',
  submittingAs: 'اس نام سے جمع کرایا جا رہا ہے',
  submitting: 'جمع کرایا جا رہا ہے...',

  searchPlaceholder: 'ٹکٹس تلاش کریں...',
  filterByStatus: 'حالت کے مطابق فلٹر',
  selectStatus: 'حالت منتخب کریں',
  noTickets: 'کوئی سپورٹ ٹکٹ نہیں ملا',

  tabOverview: 'جائزہ',
  tabNotes: 'نوٹس',
  tabTimeline: 'ٹائم لائن',
  timelineCreated: 'ٹکٹ کھولا گیا',
  timelineNoteAdded: 'نوٹ شامل کیا گیا',
  noTimeline: 'ابھی تک کوئی سرگرمی نہیں',
  none: 'کوئی نہیں',
  value: {
    open: 'کھلا',
    in_progress: 'زیر عمل',
    waiting_on_reporter: 'رپورٹر کے منتظر',
    resolved: 'حل شدہ',
    closed: 'بند',
    low: 'کم',
    medium: 'درمیانہ',
    high: 'زیادہ',
    urgent: 'فوری',
    met: 'ایس ایل اے پورا ہوا',
    breached: 'ایس ایل اے کی خلاف ورزی',
    order_issue: 'آرڈر کا مسئلہ',
    delivery_issue: 'ڈیلیوری کا مسئلہ',
    payment_issue: 'ادائیگی کا مسئلہ',
    account_issue: 'اکاؤنٹ کا مسئلہ',
    platform_bug: 'پلیٹ فارم بگ',
    malfunctioning_hardware: 'خراب ہارڈ ویئر',
    feature_request: 'فیچر کی درخواست',
    general: 'عام',
    other: 'دیگر',
    customer_to_spcc: 'کسٹمر',
    spcc_to_525k: 'داخلی',
    customer_portal: 'کسٹمر پورٹل',
    ecommerce_app: 'ای کامرس ایپ',
    admin_portal: 'ایڈمن پورٹل',
    gate_portal: 'گیٹ پورٹل',
    kiosk_portal: 'کیوسک پورٹل',
  },
  assignedTo: 'تفویض شدہ',
  unassigned: 'غیر تفویض شدہ',
  tenant: 'کرایہ دار',
  resolvedAt: 'حل کی تاریخ',
  updateStatus: 'حالت اپ ڈیٹ کریں',

  noNotes: 'ابھی تک کوئی نوٹ نہیں',
  addNote: 'نوٹ شامل کریں',
  notePlaceholder: 'نوٹ شامل کریں...',

  exportReport: 'رپورٹ برآمد کریں',
  exportPreparing: 'رپورٹ تیار کی جا رہی ہے...',
  exportSuccess: 'رپورٹ ڈاؤن لوڈ ہو گئی',
  exportError: 'رپورٹ تیار نہیں ہو سکی',
  exportEmpty: 'موجودہ فلٹرز سے مطابقت رکھنے والا کوئی ٹکٹ نہیں',
  exportTruncated: 'رپورٹ محدود کی گئی — مکمل رپورٹ کے لیے فلٹرز کم کریں',
  reportSheetSummary: 'خلاصہ',
  reportSheetTickets: 'ٹکٹس',
  reportColMetric: 'میٹرک',
  reportColValue: 'ویلیو',
  reportColPercent: 'فیصد',
  reportGeneratedAt: 'تیاری کا وقت',
  reportFiltersApplied: 'لاگو فلٹرز',
  reportFiltersNone: 'کوئی نہیں — تمام ٹکٹس',
  reportTotalTickets: 'کل ٹکٹس',
  reportBreachRate: 'SLA خلاف ورزی کی شرح',
  reportAvgResolutionHours: 'اوسط حل کا وقت (گھنٹے)',
  reportMedianResolutionHours: 'درمیانی حل کا وقت (گھنٹے)',
  reportByStatus: 'سٹیٹس کے لحاظ سے',
  reportByPriority: 'ترجیح کے لحاظ سے',
  reportByCategory: 'زمرے کے لحاظ سے',
  reportByChannel: 'چینل کے لحاظ سے',
  colDescription: 'تفصیل',
  colSourcePortal: 'ماخذ پورٹل',
  colResolutionHours: 'حل کا وقت (گھنٹے)',
  colSlaTarget: 'SLA ہدف (گھنٹے)',
  colOverdue: 'تاخیر شدہ',
  colNotes: 'نوٹس',
  yes: 'جی ہاں',
  no: 'نہیں',

  createSuccess: 'سپورٹ ٹکٹ کامیابی سے بنایا گیا',
  updateSuccess: 'سپورٹ ٹکٹ کامیابی سے اپ ڈیٹ ہو گیا',
  createError: 'سپورٹ ٹکٹ بنانے میں ناکامی',
  updating: 'اپ ڈیٹ ہو رہا ہے...',
  customerSupportTitle: 'سپورٹ',
  customerSupportSubtitle: 'اپنے آرڈرز، ڈیلیوریز اور اکاؤنٹ کے لیے مدد حاصل کریں',
  myTickets: 'میرے ٹکٹس',
  noMyTickets: 'آپ کے پاس ابھی تک کوئی سپورٹ ٹکٹ نہیں ہے',
}
